import { CAMPAIGN_OWNER_ACCENTS } from '../model/campaign'
import type { CampaignOwner, CampaignOwnerAccent } from '../model/campaign'

const ACCENT_FILL: Record<CampaignOwnerAccent, string> = {
  [CAMPAIGN_OWNER_ACCENTS.blue]: 'bg-blue-500',
  [CAMPAIGN_OWNER_ACCENTS.green]: 'bg-campaign-owner-green',
  [CAMPAIGN_OWNER_ACCENTS.amber]: 'bg-campaign-owner-amber',
}

interface CampaignOwnerCellProps {
  owner: CampaignOwner
}

/**
 * Owner avatar + name. The avatar is a single tinted initial rather than the
 * shared `Avatar` because campaigns can be owned by Automation, which has no
 * account and no picture behind it.
 */
export function CampaignOwnerCell({ owner }: CampaignOwnerCellProps) {
  return (
    <span className="flex items-center gap-1.75">
      <span
        aria-hidden="true"
        className={`flex size-5 shrink-0 items-center justify-center rounded-full text-2xs font-medium text-white ${ACCENT_FILL[owner.accent]}`}
      >
        {owner.name.charAt(0)}
      </span>
      <span className="truncate text-xs text-gray-900">{owner.name}</span>
    </span>
  )
}
